export default "__VITE_ASSET__DLjFJ_Ek__"